import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { QRCodeSVG } from 'qrcode.react';

const TableAccessQrModal = ({ show, onHide, table, qrData, loading }) => {
    const [copied, setCopied] = useState(false);
    const publicUrl = qrData?.public_url;

    const copyUrl = async () => {
        if (!publicUrl) return;
        try {
            await navigator.clipboard.writeText(publicUrl);
        } catch (_) {
            const input = document.createElement('textarea');
            input.value = publicUrl;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        }
        setCopied(true);
        window.setTimeout(() => setCopied(false), 2000);
    };

    return (
        <Modal show={show} onHide={onHide} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '1rem', fontWeight: 700 }}>
                    Acceso publico - {table?.name || 'Mesa'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center py-5 text-muted">Generando acceso publico...</div>
                ) : publicUrl ? (
                    <div className="text-center">
                        <p className="text-muted small mb-3">
                            Escanea este QR o programa esta misma URL en el NFC de la mesa.
                        </p>
                        <div className="d-inline-flex p-3 bg-white border rounded-3 mb-3">
                            <QRCodeSVG value={publicUrl} size={220} level="M" includeMargin />
                        </div>
                        <label className="form-label small fw-semibold d-block text-start">URL para QR / NFC</label>
                        <div className="input-group">
                            <input className="form-control" value={publicUrl} readOnly aria-label="URL publica de mesa" />
                            <button className="btn btn-outline-secondary" type="button" onClick={copyUrl}>
                                {copied ? 'Copiada' : 'Copiar'}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="text-center py-4 text-muted">No fue posible generar el acceso publico.</div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" type="button" onClick={onHide}>Cerrar</button>
            </Modal.Footer>
        </Modal>
    );
};

export default TableAccessQrModal;
